export enum PurchaseAssociationStatus {
	One = 'one',
	All = 'all'
};